import { TextField } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import TextArea from "Components/FormControl/TextArea/TextArea";
import { useOrderAttributeProvider } from "../context/order";

const DriverInstruction = () => {
  const formik = useFormikContext();

  const { active } = useOrderAttributeProvider();
  return (
    <div>
      <h3 className="bold mt-5">Driver Instructions (optional)</h3>
      <TextArea
        label="Driver Instructions"
        rows={3}
        className="w-100"
        style={{ height: "130px" }}
        onChangeWithEvent={formik.handleChange}
        id="delivery_information.driver_instruction"
        onBlur={formik.handleBlur}
        error={
          formik.touched?.delivery_information?.driver_instruction &&
          Boolean(formik.errors?.delivery_information?.driver_instruction)
        }
        value={formik.values.delivery_information.driver_instruction}
        disabled={active === 0 ? false : true}
      />
    </div>
  );
};

export default DriverInstruction;
